import React, { useState } from 'react';
import { connect } from 'react-redux';

import { set_go_to_page, set_selected_project } from '../../../../../../actions';

const Project = ({ id, mainImage, title, goToPage, setSelectedProject }) => {
    const [opened, setOpened] = useState(false);

    const openProject = () => {
        setSelectedProject(id);
        goToPage(3);
    };

    return (
        <div
            className="project"
            onClick={openProject}
            onMouseEnter={() => setOpened(true)}
            onMouseLeave={() => setOpened(false)}
        >
            {opened && (
                <div className="projectName">{title}</div>
            )}
            <img src={'/images/portfolios/' + mainImage} alt />
        </div>
    )
};

const mapDispatchToProps = dispatch => ({
    goToPage: page => dispatch(set_go_to_page(page)),
    setSelectedProject: id => dispatch(set_selected_project(id)),
});

export default connect(null, mapDispatchToProps)(Project);
